import gql from "graphql-tag";

export const GET_USER_FREE_TIME = gql`
  query ($input: userFreeTimeInput) {
    getUserFreeTime(input: $input)
  }
`;
